import React from 'react';
import { ConversationStyle } from 'Assistant/__generated__/client.schemas';
import {
  ActiveListeningIcon,
  CoachingIcon,
  PracticalToolsIcon,
} from './styles';

type StyleIconProps = {
  style: ConversationStyle | null;
};

export function StyleIcon({ style }: StyleIconProps) {
  switch (style) {
    case ConversationStyle.Active_Listening:
      return <ActiveListeningIcon aria-hidden={true} />;
    case ConversationStyle.Coaching:
      return <CoachingIcon aria-hidden={true} />;
    case ConversationStyle.Practical_Tools:
      return <PracticalToolsIcon aria-hidden={true} />;
    default:
      return null;
  }
}
